export const apiGenerationModalStyles = {}
